<style lang="less">
  @import "./RealNameAgree.less";
</style>

<template>
  <div class="agree">
    <h3>《电话用户真实身份信息登记规定》</h3>
    <p>2015年9月1日起，在运营商的实体营业厅、网上营业厅、授权代理网点等办理固定电话装机、移机、过户，移动电话(含无线上网卡)开户、过户等入网手续，用户须出示本人有效证件原件，委托他人办理时，受托人须出示用户和受托人的有效证件原件。</p>
    <p>中国联通、中国移动、中国电信将启动实施电话用户实名登记工作，用户通过运营商自有营业厅、授权合作社会渠道和网上营业厅办理移动电话、固定电话、无线上网卡业务，必须进行身份登记。</p>
    <p>第一条 为了规范电话用户真实身份信息登记活动，保障电话用户和电信业务经营者的合法权益，维护网络信息安全，促进电信业的健康发展，根据《全国人民代表大会常务委员会关于加强网络信息保护的决定》和《中华人民共和国电信条例》，制定本规定。</p>
    <p>第二条 中华人民共和国境内的电话用户真实身份信息登记活动，适用本规定。</p>
    <p>第三条 本规定所称电话用户真实身份信息登记，是指电信业务经营者为用户办理固定电话、移动电话（含无线上网卡，下同）等入网手续，在与用户签订协议或者确认提供服务时，如实登记用户提供的真实身份信息的活动。</p>
    <p>本规定所称入网，是指用户办理固定电话装机、移机、过户，移动电话开户、过户等。</p>
    <p>第四条 工业和信息化部和各省、自治区、直辖市通信管理局（以下统称电信管理机构）依法对电话用户真实身份信息登记工作实施监督管理。</p>
    <p>第五条 电信业务经营者应当依法登记和保护电话用户办理入网手续时提供的真实身份信息。</p>
    <p>第六条 电信业务经营者为用户办理入网手续时，应当要求用户出示有效证件、提供真实身份信息，用户应当予以配合。</p>
    <p>用户委托他人办理入网手续的，电信业务经营者应当要求受托人出示用户和受托人的有效证件，并提供用户和受托人的真实身份信息。</p>
    <p>第七条 个人办理电话用户真实身份信息登记的，可以出示下列有效证件之一：</p>
    <ul>
      <li>（一）居民身份证、临时居民身份证或者户口簿；</li>
      <li>（二）中国人民解放军军人身份证件、中国人民武装警察身份证件；</li>
      <li>（三）港澳居民来往内地通行证、台湾居民来往大陆通行证或者其他有效旅行证件；</li>
      <li>（四）外国公民护照；</li>
      <li>（五）法律、行政法规和国家规定的其他有效身份证件。</li>
    </ul>
    <p>第八条 单位办理电话用户真实身份信息登记的，可以出示下列有效证件之一：</p>
    <ul>
      <li>（一）组织机构代码证；</li>
      <li>（二）营业执照；</li>
      <li>（三）事业单位法人证书或者社会团体法人登记证书；</li>
      <li>（四）法律、行政法规和国家规定的其他有效证件或者证明文件。</li>
      <li>单位办理登记的，除出示以上证件之一外，还应当出示经办人的有效证件和单位的授权书。</li>
    </ul>
    <p>第九条 电信业务经营者应当对用户出示的证件进行查验，并如实登记证件类别以及证件上所记载的姓名（名称）、号码、住址信息；对于用户委托他人办理入网手续的，应当同时查验受托人的证件并登记受托人的上述信息。</p>
    <p>为了方便用户提供身份信息、办理入网手续，保护用户的合法权益，电信业务经营者复印用户身份证件的，应当在复印件上注明电信业务经营者名称、复印目的和日期。</p>
    <p>第十条 用户拒绝出示有效证件，拒绝提供其证件上所记载的身份信息，冒用他人的证件，或者使用伪造、变造的证件的，电信业务经营者不得为其办理入网手续。</p>
    <p>第十一条 电信业务经营者在向电话用户提供服务期间及终止向其提供服务后两年内，应当留存用户办理入网手续时提供的身份信息和相关材料。</p>
    <p>第十二条 电信业务经营者应当建立健全用户真实身份信息保密管理制度。</p>
    <p>电信业务经营者及其工作人员对在提供服务过程中登记的用户真实身份信息应当严格保密，不得泄露、篡改或者毁损，不得出售或者非法向他人提供，不得用于提供服务之外的目的。</p>
    <p>第十三条 电话用户真实身份信息发生或者可能发生泄露、毁损、丢失的，电信业务经营者应当立即采取补救措施；造成或者可能造成严重后果的，应当立即向相关电信管理机构报告，配合相关部门进行的调查处理。</p>
    <p>电信管理机构应当对报告或者发现的可能违反电话用户真实身份信息保护规定的行为的影响进行评估；影响特别重大的，相关省、自治区、直辖市通信管理局应当向工业和信息化部报告。电信管理机构在依据本规定作出处理决定前，可以要求电信业务经营者暂停有关行为，电信业务经营者应当执行。</p>
    <p>第十四条 电信业务经营者委托他人代理电话入网手续、登记电话用户真实身份信息的，应当对代理人的用户真实身份信息登记和保护工作进行监督和管理，不得委托不符合本规定有关用户真实身份信息登记和保护要求的代理人代办相关手续。</p>
    <p>第十五条 电信业务经营者应当对其电话用户真实身份信息登记和保护情况每年至少进行一次自查，并对其工作人员进行电话用户真实身份信息登记和保护相关知识、技能和安全责任培训。</p>
    <p>第十六条 电信管理机构应当对电信业务经营者的电话用户真实身份信息登记和保护情况实施监督检查。电信管理机构实施监督检查时，可以要求电信业务经营者提供相关材料，进入其生产经营场所调查情况，电信业务经营者应当予以配合。</p>
    <p>电信管理机构实施监督检查，应当记录监督检查的情况，不得妨碍电信业务经营者正常的经营或者服务活动，不得收取任何费用。</p>
    <p>电信管理机构及其工作人员对在实施监督检查过程中知悉的电话用户真实身份信息应当予以保密，不得泄露、篡改或者毁损，不得出售或者非法向他人提供。</p>
    <p>第十七条 电信业务经营者违反本规定第六条、第九条至第十五条的规定，或者不配合电信管理机构依照本规定开展的监督检查的，由电信管理机构依据职权责令限期改正，予以警告，可以并处一万元以上三万元以下罚款，向社会公告。其中，《中华人民共和国电信条例》规定法律责任的，依照其规定处理；构成犯罪的，依法追究刑事责任。</p>
    <p>第十八条 用户以冒用、伪造、变造的证件办理入网手续的，电信业务经营者不得为其提供服务，并由相关部门依照《中华人民共和国居民身份证法》、《中华人民共和国治安管理处罚法》、《现役军人和人民武装警察居民身份证申领发放办法》等规定处理。</p>
    <p>第十九条 电信管理机构工作人员在对电话用户真实身份信息登记工作实施监督管理的过程中玩忽职守、滥用职权、徇私舞弊的，依法给予处理；构成犯罪的，依法追究刑事责任。</p>
    <p>第二十条 电信业务经营者应当通过电话、短信息、书面函件或者公告等形式告知用户并采取便利措施，为本规定施行前尚未提供真实身份信息或者所提供身份信息不全的电话用户补办登记手续。</p>
    <p>电信业务经营者为电话用户补办登记手续，不得擅自加重用户责任。</p>
    <p>电信业务经营者应当在向尚未提供真实身份信息的用户确认提供服务时，要求用户提供真实身份信息。</p>
    <p>第二十一条 本规定自2015年9月1日起全面施行。</p>
  </div>
</template>

<script>
import RealNameAgree from './RealNameAgree.js'
export default {
  ...RealNameAgree
}
</script>
